import { useLocation, useNavigate } from "react-router-dom";
import "./ArrowGoBack.css";

const ArrowGoBack = (props) => {
  const { max, callbackUrl, forcedPrev } = props;
  const navigate = useNavigate();
  const url = useLocation();
  let array = url.pathname.split("/");
  // Si forcedPrev existe y es un array, agregar esos valores al inicio
  let word = array.pop();
  Number(word) && array.pop();
  const goBack = (x) => {
    if (x === "") return;
    navigate(`/${x}${callbackUrl ? callbackUrl : ""}`);
  };
  var href = max
    ? url.pathname.split("/").slice(1, max + 1)
    : url.pathname.split("/");

  if (forcedPrev && Array.isArray(forcedPrev) && forcedPrev.length > 0) {
    const filteredForcedPrev = forcedPrev.filter((item) => item && item !== "");

    // Reconstruir el array con los valores de forcedPrev al inicio
    href = [...filteredForcedPrev, ...href];
  }
  var migas = href.filter((x) => {
    const isNumero = Number(x);
    return (
      x !== "dashboard" && x !== "" && Number.isInteger(isNumero) === false
    );
  });

  return (
    // <div>
    <div className="arrow-container">
      {migas.map((x, i, h) => {
        const ruta = x.replace(/-/g, " ").toUpperCase();
        let rutaReal = x;
        if (x === migas[migas.length - 1]) rutaReal = "";
        if (migas.length === 1) {
          return (
            <div className="path-con firstPathC" key={i}>
              <div
                className="arrow-path PathSel"
                onClick={() => goBack(rutaReal)}
              >
                {ruta}
              </div>
            </div>
          );
        } else if (i === 0) {
          return (
            <div className="path-con firstPathC" key={i}>
              <div className="arrow-path" onClick={() => goBack(rutaReal)}>
                {ruta}
              </div>
            </div>
          );
        } else if (i === migas.length - 1) {
          return (
            <div className="path-con" key={i}>
              <span className="barra-paht" onClick={() => goBack(rutaReal)}>
                /
              </span>
              <div
                className="arrow-path PathSel"
                onClick={() => goBack(rutaReal)}
              >
                {ruta}
              </div>
            </div>
          );
        } else {
          return (
            <div className="path-con" key={i}>
              <span className="barra-paht">/</span>
              <div className="arrow-path" onClick={() => goBack(rutaReal)}>
                {ruta}
              </div>
            </div>
          );
        }
      })}
    </div>
    // </div>
  );
};

export default ArrowGoBack;
